<template>
    <div class="progress-bar-area">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="card-box-style">
                        <div class="others-title">
                            <h3>Only Slides</h3>
                        </div>

                        <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-1">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-2.jpg" class="d-block w-100" alt="carousel-2">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-3">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card-box-style">
                        <div class="others-title">
                            <h3>With Controls Slides</h3>
                        </div>
                        
                        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-1">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-2.jpg" class="d-block w-100" alt="carousel-2">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-3">
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card-box-style">
                        <div class="others-title">
                            <h3>With Indicators Slides</h3>
                        </div>
                        
                        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            </div>
                                
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-1">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-2.jpg" class="d-block w-100" alt="carousel-2">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-3">
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card-box-style">
                        <div class="others-title">
                            <h3>With Captions Slides</h3>
                        </div>
                        
                        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            </div>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="...">
                                    <div class="carousel-caption d-none d-md-block">
                                    <h5>First slide label</h5>
                                    <p>Some representative placeholder content for the first slide.</p>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-2.jpg" class="d-block w-100" alt="...">
                                    <div class="carousel-caption d-none d-md-block">
                                    <h5>Second slide label</h5>
                                    <p>Some representative placeholder content for the second slide.</p>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-3.jpg" class="d-block w-100" alt="...">
                                    <div class="carousel-caption d-none d-md-block">
                                    <h5>Third slide label</h5>
                                    <p>Some representative placeholder content for the third slide.</p>
                                    </div>
                                </div>
                            </div>

                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card-box-style">
                        <div class="others-title">
                            <h3>Crossfade Slides</h3>
                        </div>
                        
                        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../../assets/images/carousel/carousel-1.jpg" class="d-block w-100" alt="carousel-1">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-2.jpg" class="d-block w-100" alt="carousel-2">
                                </div>
                                <div class="carousel-item">
                                    <img src="../../assets/images/carousel/carousel-3.jpg" class="d-block w-100" alt="carousel-3">
                                </div>
                            </div>

                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CarouselContent'
}
</script>